import { Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import '../../../../scss/pages/Employee helpdesk/HelpDeskChatbox/Message/Message.scss'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { useNavigate } from "react-router";
import { EMPLOYEE_HELPDESK_VIEW_IMAGES } from "../../../../utils/Constants";
import moment from "moment";

const Message = ({ name, text, files, isUser, time, onEdit, onDelete, setAddComment }) => {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const handleShowImage = () => {
        navigate(EMPLOYEE_HELPDESK_VIEW_IMAGES, { state: { images: files } })
    }

    const handleOnEdit = () => {
        setAddComment(true)
        onEdit()
        setAnchorEl(null);
    }

    const handleOnDelete = () => {
        onDelete()
        setAnchorEl(null);
    }

    const renderImages = (files) => {
        if (files?.length > 4) {
            const count = files?.length - 3;
            return (
                <div className="messageContainer_message_filesContainer_Parent">
                    {files?.slice(0, 3).filter((item) => item.attachmentUrl !== "")?.map((file, index) => {
                        return (
                            <div key={index} className="messageContainer_message_filesContainer_Parent_fileItem-grid">
                                <img src={file?.attachmentUrl} alt='' width='100%' height='100%' />
                            </div>
                        )
                    })}
                    <div className="messageContainer_message_filesContainer_Parent_filesCount">{`+${count}`}</div>
                </div>
            );
        } else {
            return files?.filter((item) => item?.attachmentUrl !== "")?.map((file, index) => {
                return (
                    <div key={index} className="messageContainer_message_fileItem">
                        <img src={file?.attachmentUrl} alt='' width='100%' height='100%' />
                    </div>
                )
            });
        }
    };


    return (
        <div className={`messageContainer ${isUser ? "messageContainer_user" : "messageContainer_opponent"}`}>
            {(files?.length > 0 || text !== '') && <div className={`messageContainer_message ${isUser ? "messageContainer_message_user" : "messageContainer_message_opponent"}`}>
                <div className='messageContainer_message_Name-Edit'>
                    <Typography sx={{ whiteSpace: "nowrap", color: "#FFF", fontSize: "11px", fontWeight: 700, opacity: 0.6 }}>{name}</Typography>
                    {isUser && <button aria-describedby={id} onClick={handleClick}> <MoreVertRoundedIcon sx={{ color: "rgba(255, 255, 255, 1)", width: "15px", height: "15px", padding: "3px 0 3px 3px" }} /></button>}
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}>
                        <div className="messageContainer_message_Name-Edit_Card">
                            <div className="messageContainer_message_Name-Edit_Card_Edit">
                                <Typography sx={{ whiteSpace: "nowrap", color: "#FFF", fontSize: "12px", fontWeight: 400, opacity: 0.6 }} onClick={handleOnEdit}>Edit</Typography>
                            </div>

                            <div className="messageContainer_message_Name-Edit_Card_Delete">
                                <Typography sx={{ whiteSpace: "nowrap", color: "#FFF", fontSize: "12px", fontWeight: 400, opacity: 0.6 }} onClick={handleOnDelete}>Delete</Typography>
                            </div>
                        </div>
                    </Popover>
                </div>
                {files && (
                    <div className="messageContainer_message_filesContainer" onClick={handleShowImage}>
                        {renderImages(files)}
                    </div>
                )}
                <div className="messageContainer_message_text">
                    {text && <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", opacity: 0.7 }}>{text}</Typography>}
                </div>
                <div className="messageContainer_message_time">
                    <Typography sx={{ whiteSpace: "nowrap", color: "#FFF", fontSize: "9px", fontWeight: 400, opacity: 0.6, marginTop: "3px" }}>{moment(time).format("DD MMM YYYY, HH:mm")}</Typography>
                </div>
            </div>}
        </div>

    );
};

export default Message;
